module.exports = __webpack_public_path__ + "img/salvador.2b1df2ca.jpg";